module.exports = __webpack_public_path__ + "img/logo-icon-lg.e2a2778a.png";